import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Se descarga al instante en PDF tras el pago. Apenas confirmas, recibes un email con tu enlace de descarga y puedes empezar a usar el kit en menos de 5 minutos, desde tablet, móvil o PC.'
}, {
  q: '¿Es seguro pagar?',
  a: 'Sí, usamos pasarelas de pago cifradas y 100% seguras. Tus datos nunca se comparten.'
}, {
  q: '¿Se paga en dólares?',
  a: 'Los 17 USD se convierten automáticamente a tu moneda local (Pesos, Soles, etc.) al momento de pagar a través de la pasarela.'
}, {
  q: '¿Es un solo pago?',
  a: 'Sí, pagas una vez y el material es tuyo para siempre — sin suscripciones, sin pagos recurrentes, sin fechas de vencimiento.'
}, {
  q: '¿Sirve para entrenadores con poca experiencia?',
  a: '¡Por supuesto! El kit está pensado tanto para entrenadores nuevos que necesitan estructura, como para profesionales con años de experiencia que buscan optimizar su tiempo. Los tomos incluyen progresiones claras desde Mini Vóley hasta avanzado.'
}, {
  q: '¿Los 6 bonos y el Kit Táctico están incluidos en el precio?',
  a: 'Sí, los 6 bonos estratégicos y el Kit Táctico Pro están incluidos sin costo adicional en esta oferta especial de lanzamiento.'
}, {
  q: '¿Qué pasa con jugadores de distintos niveles al mismo tiempo?',
  a: 'La Guía de Variaciones en 3 Niveles (Bono 03) resuelve exactamente eso. Tienes el mismo drill adaptado a 3 dificultades para que cada jugador trabaje a su nivel.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'Todo el material viene en PDF de alta calidad, optimizado para visualizar en tablet, móvil y PC, o para imprimir si prefieres llevarlo en papel a la cancha. No necesitas ningún software especial.'
}, {
  q: '¿Tiene garantía de devolución?',
  a: 'Sí, tienes 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas, sin formularios y sin trámites complicados.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-20 sm:py-24 px-4" data-id="element-148">
      <div className="max-w-3xl mx-auto" data-id="element-149">
        <div className="text-center mb-10 sm:mb-12" data-id="element-150">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-151">
            ❓ Resolvemos tus dudas
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-152">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4 mb-12 sm:mb-16" data-id="element-153">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_8px_24px_-12px_rgba(30,64,175,0.15)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-154">
                <button className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-155">
                  <span className={`font-bold text-base sm:text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-156">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-157">
                    +
                  </span>
                </button>
                <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 sm:pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-158">
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-159">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-160">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_15px_40px_-10px_rgba(0,128,96,0.4)]" data-id="element-161">
            🚀 ¡SÍ! QUIERO EL MEGAPACK VOLEY LISTO
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-162">
            <span data-id="element-163">⚡ Acceso inmediato</span>
            <span data-id="element-164">•</span>
            <span data-id="element-165">🛡️ Garantía 7 días</span>
            <span data-id="element-166">•</span>
            <span data-id="element-167">💳 USD 17 pago único</span>
          </p>
        </div>
      </div>
    </section>;
}